module.exports = __webpack_public_path__ + "img/1554299543230705665.4f48bac0.jpg";